import axios from "axios";

export const GENTLEFLOW_API = "https://gentleflow-production.up.railway.app/api";
const authConfig = (token) => token ? { headers: { Authorization: `Bearer ${token}` } } : {};

export async function getPlusConfig(token) {
  const { data } = await axios.get(`${GENTLEFLOW_API}/plus/config`, authConfig(token));
  return data;
}
export async function getPlusStatus(token) {
  const { data } = await axios.get(`${GENTLEFLOW_API}/plus/status`, authConfig(token));
  return data;
}
export async function savePlusRegion(region, token) {
  const { data } = await axios.put(`${GENTLEFLOW_API}/plus/region`, { region }, authConfig(token));
  return data;
}
export async function verifyPlusCoupon(couponCode, token) {
  const { data } = await axios.post(`${GENTLEFLOW_API}/plus/verify-coupon`, { coupon_code: couponCode }, authConfig(token));
  return data;
}
export async function subscribeToPlus(region, couponCode, token) {
  const { data } = await axios.post(`${GENTLEFLOW_API}/plus/subscribe`, { region, coupon_code: couponCode || undefined }, authConfig(token));
  if (data?.checkout_url) window.location.assign(data.checkout_url);
  if (data?.short_url) window.location.assign(data.short_url);
  return data;
}
export async function cancelPlus(token) {
  const { data } = await axios.post(`${GENTLEFLOW_API}/plus/cancel`, {}, authConfig(token));
  return data;
}
